export default __webpack_public_path__ + "static/media/hostaway_step6.b3effe3f.jpg";